<template>
    <div class="container-fluid">
        <div
            v-if="exists && customer.id"
            class="row"
        >
            <div class="col-sm-12 col-md-6">
                <div class="card">
                    <div class="card-body">
                        <h4>Customer details</h4>
                        <div class="form-group">
                            <label for="company_name">Company name:</label>
                            <input
                                id="company_name"
                                v-model="customer.company_name"
                                type="text"
                                readonly
                                placeholder="Company name"
                                class="form-control not-input"
                            >
                        </div>

                        <div class="form-group">
                            <label for="billing_name">Billing contact name:</label>
                            <input
                                id="billing_name"
                                v-model="customer.billing_name"
                                type="text"
                                readonly
                                placeholder="Billing contact name"
                                class="form-control not-input"
                            >
                        </div>
                        <div class="row">
                            <div
                                v-if="customer.billing_email"
                                class="form-group col-sm-12"
                            >
                                <label>Billing email:</label>
                                <br>
                                <a
                                    :href="'mailto:' + customer.billing_email"
                                    title="Click to email"
                                >{{
                                    customer.billing_email }}</a>
                            </div>
                            <div
                                v-if="customer.billing_telephone"
                                class="form-group col-sm-12"
                            >
                                <label>Billing telephone:</label>
                                <br>
                                <a
                                    :href="'tel:' + customer.billing_telephone"
                                    title="Click to call"
                                >{{
                                    customer.billing_telephone }}</a>
                            </div>
                        </div>

                        <div
                            v-if="customer.responsible_person_name"
                            class="form-group"
                        >
                            <label for="responsible_person_name">Responsible person name:</label>
                            <input
                                id="responsible_person_name"
                                v-model="customer.responsible_person_name"
                                type="text"
                                readonly
                                placeholder="Responsible person name"
                                class="form-control not-input"
                            >
                        </div>
                        <div class="row">
                            <div
                                v-if="customer.responsible_person_email"
                                class="form-group col-sm-12"
                            >
                                <label>Responsible person email:</label>
                                <br>
                                <a
                                    :href="'mailto:' + customer.responsible_person_email"
                                    title="Click to email"
                                >{{
                                    customer.responsible_person_email }}</a>
                            </div>
                            <div
                                v-if="customer.responsible_person_telephone"
                                class="form-group col-sm-12"
                            >
                                <label>Responsible person telephone:</label>
                                <br>
                                <a
                                    :href="'tel:' + customer.responsible_person_telephone"
                                    title="Click to call"
                                >{{
                                    customer.responsible_person_telephone }}</a>
                            </div>
                        </div>

                        <div class="row">
                            <div class="form-group col-sm-12">
                                <label for="response_time_hours">Response Time:</label>
                                <input
                                    id="response_time_hours"
                                    :value="customer.response_time_hours + ' hours'"
                                    type="text"
                                    readonly
                                    placeholder="Hours"
                                    class="form-control not-input"
                                >
                            </div>
                        </div>

                        <div
                            v-if="customer.overdue"
                            class="row"
                        >
                            <div class="form-group col-sm-12">
                                <span class="overdue">ACCOUNT IS OVERDUE</span>
                            </div>
                        </div>
                        <div
                            v-if="customer.proforma"
                            class="row"
                        >
                            <div class="form-group col-sm-12">
                                <span class="overdue">ACCOUNT IS PROFORMA/CASH</span>
                            </div>
                        </div>
                        <hr>

                        <div class="form-group">
                            <a
                                v-if="customer.billing_email"
                                :href="'mailto:' + customer.billing_email"
                                class="btn btn-success"
                            >
                                <i class="fa fa-envelope" /> Email</a>
                            <a
                                v-if="customer.billing_telephone"
                                :href="'tel:' + customer.billing_telephone"
                                class="btn btn-success"
                            >
                                <i class="fa fa-phone" /> Call</a>
                            <router-link
                                :to="{name: routeBase + '.customers.edit', params: { id: customer.id }}"
                                class="btn btn-outline-info"
                            >
                                <i class="fa fa-pencil-alt" /> Edit
                            </router-link>
                            <router-link
                                v-if="isOffice"
                                :to="{name: routeBase + '.customers.products', params: { id: customer.id }}"
                                class="btn btn-outline-info"
                            >
                                <i class="fa fas fa-box" /> Product Prices
                            </router-link>
                            <router-link
                                v-if="isOffice"
                                :to="{name: routeBase + '.customers.service-products', params: { id: customer.id }}"
                                class="btn btn-outline-info"
                            >
                                <i class="fa fa-clipboard" /> Service Product Prices
                            </router-link>
                            <button
                                v-if="isOffice"
                                type="button"
                                class="btn btn-outline-info"
                                @click="openPostcodeFeeModal"
                            >
                                <i class="fa fa-map-marker-alt" /> Postcode Fee Prices
                            </button>
                            <button
                                v-if="isOffice"
                                class="btn btn-outline-danger"
                                @click="confirmDelete"
                            >
                                <i class="fa fa-times" /> Delete
                            </button>
                            <activity-log
                                v-if="customer.id"
                                :id="customer.id"
                                model="Customer"
                            />
                            <router-link
                                :to="'../customers'"
                                class="btn btn-outline-secondary"
                            >
                                Back
                            </router-link>
                        </div>
                    </div>
                </div>
                <div
                    v-if="isOffice"
                    class="card"
                >
                    <div class="card-body">
                        <h4>Latest jobs</h4>
                        <p v-if="!jobs">
                            No recent jobs for this customer
                        </p>

                        <div v-if="jobs">
                            <input
                                v-model="jobSearch"
                                type="text"
                                class="form-control"
                                placeholder="Search..."
                            >
                        </div>

                        <br>

                        <div
                            v-if="jobs.length > 5"
                            class="text-right"
                        >
                            <router-link
                                :to="{ path: '/office/jobs/schedule', query: { customer_id: customer.id }}"
                                class="btn btn-primary"
                            >
                                <i class="fa fa-plus" /> New job
                            </router-link>
                        </div>

                        <br>

                        <table
                            v-if="jobs"
                            class="table"
                        >
                            <thead>
                                <tr>
                                    <th>Job</th>
                                    <th>Site</th>
                                    <th>Time</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr
                                    v-for="(job, index) in filteredJobs"
                                    v-show="index < 11 || expandJobs"
                                    :key="job.id"
                                >
                                    <td>
                                        <router-link :to="{name: 'office.jobs.show', params: {id: job.id}}">
                                            {{ job.name }}
                                        </router-link>
                                    </td>
                                    <td>
                                        <span v-if="!job.site">-</span>
                                        <span v-if="job.site">{{ job.site.name }}</span>
                                    </td>

                                    <td v-if="job.first_time_slot">
                                        {{ job.first_time_slot.start.format('DD/MM/YYYY') }}
                                    </td>
                                    <td v-if="!job.first_time_slot">
                                        -
                                    </td>
                                </tr>

                                <tr>
                                    <td colspan="4">
                                        <button
                                            v-if="!expandJobs && filteredJobs.length > 10"
                                            class="btn btn-light"
                                            @click="expandJobs = true"
                                        >
                                            Show All Jobs
                                        </button>
                                        <button
                                            v-if="expandJobs && filteredJobs.length > 10"
                                            class="btn btn-light"
                                            @click="expandJobs = false"
                                        >
                                            Hide Jobs
                                        </button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>

                        <div class="text-right">
                            <router-link
                                :to="{ path: '/office/jobs/schedule', query: { customer_id: customer.id }}"
                                class="btn btn-primary"
                            >
                                <i class="fa fa-plus" /> New job
                            </router-link>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-sm-12 col-md-6">
                <div
                    v-if="customer.billing_address_id"
                    class="card"
                >
                    <div class="card-body">
                        <h4>Customer billing address</h4>
                        <address>
                            <span v-if="customer.address_line_1">{{ customer.address_line_1 }}</span>
                            <span v-if="customer.address_line_2">{{ customer.address_line_2 }}</span>
                            <span v-if="customer.address_line_3">{{ customer.address_line_3 }}</span>
                            <span v-if="customer.town">{{ customer.town }}</span>
                            <span v-if="customer.region">{{ customer.region }}</span>
                            <span v-if="customer.country">{{ customer.country }}</span>
                            <span v-if="customer.postcode">{{ customer.postcode }}</span>
                        </address>
                    </div>
                </div>

                <div class="card">
                    <div class="card-body">
                        <h4>Notes</h4>
                        <comments />
                    </div>
                </div>

                <div class="card">
                    <div class="card-body">
                        <h4>Customer sites</h4>
                        <p v-if="!customer.sites">
                            Customer has no sites at the moment
                        </p>

                        <div v-if="customer.sites">
                            <input
                                v-model="siteSearch"
                                type="text"
                                class="form-control"
                                placeholder="Search..."
                            >
                        </div>

                        <br>

                        <div
                            v-if="sites.length > 5 && isOffice"
                            class="text-right"
                        >
                            <router-link
                                :to="{name: 'office.sites.new', params: { customer_id: customer.id }}"
                                class="btn btn-primary"
                            >
                                <i class="fa fa-plus" /> New Site
                            </router-link>
                        </div>

                        <br>

                        <table
                            v-if="customer.sites"
                            class="table"
                        >
                            <tr
                                v-for="(site, index) in sites"
                                v-show="index < 11 || expandSites"
                                :key="site.id"
                            >
                                <td>
                                    <router-link
                                        v-if="isOffice"
                                        :to="{name: 'office.sites.edit', params: { customer_id: customer.id, id: site.id }}"
                                    >
                                        #{{ site.site_no }} {{ site.name }}
                                    </router-link>
                                    <span v-if="isEngineer">#{{ site.site_no }} {{ site.name }}</span>
                                </td>
                                <td class="text-right">
                                    <router-link
                                        v-if="isOffice"
                                        :to="{name: 'office.sites.edit', params: { customer_id: customer.id, id: site.id }}"
                                    >
                                        <i class="fa fa-pencil-alt" />
                                    </router-link>
                                </td>
                            </tr>

                            <tr>
                                <td colspan="2">
                                    <button
                                        v-if="!expandSites && sites.length > 10"
                                        class="btn btn-light"
                                        @click="expandSites = true"
                                    >
                                        Show All Sites
                                    </button>
                                    <button
                                        v-if="expandSites && sites.length > 10"
                                        class="btn btn-light"
                                        @click="expandSites = false"
                                    >
                                        Hide Sites
                                    </button>
                                </td>
                            </tr>
                        </table>

                        <div
                            v-if="isOffice"
                            class="text-right"
                        >
                            <router-link
                                :to="{name: 'office.sites.new', params: { customer_id: customer.id }}"
                                class="btn btn-primary"
                            >
                                <i class="fa fa-plus" /> New Site
                            </router-link>
                        </div>
                    </div>
                </div>

                <div
                    v-if="isOffice"
                    class="card"
                >
                    <div class="card-body">
                        <h4>Forms</h4>
                        <p v-if="!forms.length && !formsLoading">
                            No forms for this customer
                        </p>
                        <p v-if="formsLoading">
                            Loading forms...
                        </p>

                        <div v-if="forms">
                            <input
                                v-model="formSearch"
                                type="text"
                                class="form-control"
                                placeholder="Search..."
                            >
                        </div>

                        <div class="text-right">
                            <button
                                v-if="forms.length > 5"
                                class="btn btn-primary mr-sm-2"
                                type="button"
                                @click.prevent="newForm()"
                            >
                                <i class="fa fa-plus" /> New Form
                            </button>
                        </div>

                        <br>

                        <table
                            v-if="forms.length"
                            class="table"
                        >
                            <thead>
                                <tr>
                                    <th>ID</th>
                                    <th>Form</th>
                                    <th>Job + Site</th>
                                    <th>Updated</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr
                                    v-for="(form, index) in filteredForms"
                                    v-show="index < 11 || expandForms"
                                    :key="form.id"
                                >
                                    <td>
                                        <router-link :to="{name: 'office.forms.edit', params: {id: form.id}}">
                                            #{{ (form.id).pad(4) }}
                                        </router-link>
                                    </td>
                                    <td>
                                        <router-link :to="{name: 'office.forms.edit', params: {id: form.id}}">
                                            {{ form.name }}
                                        </router-link>
                                    </td>
                                    <td>
                                        <router-link
                                            v-if="form.job"
                                            :to="{name: 'office.jobs.show', params: {id: form.job_id}}"
                                        >
                                            {{ form.job.name }}
                                        </router-link>
                                        <span v-if="form.job && form.site">-</span>
                                        <router-link
                                            v-if="form.site"
                                            :to="{name: 'office.sites.edit', params: {id: form.site_id}}"
                                        >
                                            {{ form.site.name }} {{ form.site.address ? form.site.address.postcode : '' }}
                                        </router-link>
                                    </td>
                                    <td>
                                        {{ form.updated_at | date }}
                                    </td>
                                </tr>

                                <tr>
                                    <button
                                        v-if="forms.length > 10 && !expandForms"
                                        class="btn btn-light"
                                        @click="expandForms = true"
                                    >
                                        Show All Forms
                                    </button>
                                    <button
                                        v-if="forms.length > 10 && expandForms"
                                        class="btn btn-light"
                                        @click="expandForms = false"
                                    >
                                        Hide Forms
                                    </button>
                                </tr>
                            </tbody>
                        </table>

                        <div class="text-right">
                            <button
                                class="btn btn-primary mr-sm-2"
                                type="button"
                                @click.prevent="newForm()"
                            >
                                <i class="fa fa-plus" /> New Form
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div
            v-if="!exists"
            class="row"
        >
            <div class="col-sm-12">
                <p class="danger">
                    This customer does not exist, it may have been deleted
                </p>
                <router-link :to="{name: routeBase + '.customers.show'}">
                    View Customers
                </router-link>
            </div>
        </div>
        <delete-customer
            v-if="isOffice"
            ref="deleteModals"
            :customer="customer"
        />
        <error-modal
            ref="errorModal"
            :action="errorClose"
        />
        <new-form-modal
            ref="newFormModal"
            :params="{customer_id: customer.id}"
            route="routeBase"
        />
        <customer-postcode-fee-modal
            v-if="postcodeFeeModalOpen && customer.id"
            :customer-id="customer.id"
            :existing-fee="postcodeFeeModalExisting"
            @close="postcodeFeeModalOpen = false"
            @saved="onPostcodeFeeModalSaved"
            @deleted="onPostcodeFeeModalDeleted"
        />
    </div>
</template>
<script>
import CustomerService from "../../../services/CustomerService";
import CustomerPostcodeFeeService from "../../../services/CustomerPostcodeFeeService";
import DeleteComponent from "./DeleteComponent.vue";
import ErrorModal from "../../modals/ErrorComponent.vue";
import NewFormModal from "../../forms/NewFormModal.vue";
import * as moment from "moment";
import RouterBase from '../../../mixins/RouterBaseMixin';
import Comments from '../../CommentsComponent.vue';
import UsesComments from '../../../mixins/UsesComments';
import CustomerPostcodeFeeModal from './CustomerPostcodeFeeModal.vue';


export default {
    components: {
        "delete-customer": DeleteComponent,
        ErrorModal,
        'new-form-modal': NewFormModal,
        'comments': Comments,
        'customer-postcode-fee-modal': CustomerPostcodeFeeModal,
    },
    mixins: [
        RouterBase,
        UsesComments,
    ],
    data: function () {
        return {
            id: null,
            customer: {},
            customerService: CustomerService,
            addressLines: ["address_line_1", "address_line_2"],
            exists: true,
            expandJobs: false,
            expandSites: false,
            expandForms: false,
            jobSearch: '',
            formSearch: '',
            siteSearch: '',
            jobs: [],
            formsLoading: false,
            forms: [],
            postcodeFee: null,
            postcodeFeeModalOpen: false,
            postcodeFeeModalExisting: null,
        };
    },

    computed: {
        filteredJobs: function () {
            if (!this.jobSearch) {
                return this.jobs;
            }

            const search = this.jobSearch.toLowerCase();
            return this.jobs.filter(job => {

                let result =  job.name.toLowerCase().includes(search) || job.id === search;

                if (job.site) {
                    return result || job.site.name.toLowerCase().includes(search);
                }

                return result;
            });
        },

        filteredForms: function () {
            if (!this.formSearch) {
                return this.forms;
            }

            const search = this.formSearch.toLowerCase();
            return this.forms.filter(form => {

                return  form.name.toLowerCase().includes(search) || form.id === search || form .doc_no === search;
            });
        },

        sites: function () {
            if (!this.customer) {
                return  [];
            }

            if (!this.siteSearch) {
                return this.customer.sites;
            }

            const search = this.siteSearch.toLowerCase();
            return this.customer.sites.filter(site => {

                if (!site.address) {
                    return site.name.toLowerCase.includes(search);
                }

                return  site.name.toLowerCase().includes(search) ||
                    String(site.address.address_line_1).toLowerCase().includes(search) ||
                    String(site.address.region).toLowerCase().includes(search) ||
                    String(site.address.town).toLowerCase().includes(search) ||
                    String(site.address.postcode).toLowerCase().includes(search) ||
                    String(site.site_no).toLowerCase().includes(search);
            });
        }
    },

    mounted: function () {
        this.id = this.$route.params.id;
        this.loadPostcodeFee();
        this.loadCustomer();
    },

    methods: {
        parsePostcodeFeePayload: function (res) {
            const d = res.data;
            if (!d) {
                return null;
            }
            if (d.data) {
                return d.data;
            }
            if (d.id != null && (d.service_fee !== undefined || d.unit_fee !== undefined)) {
                return d;
            }
            return null;
        },
        loadPostcodeFee: function () {
            if (!this.id) {
                return;
            }
            CustomerPostcodeFeeService.get(this.id).then(res => {
                this.postcodeFee = this.parsePostcodeFeePayload(res);
            }).catch(() => {
                this.postcodeFee = null;
            });
        },
        openPostcodeFeeModal: function () {
            CustomerPostcodeFeeService.get(this.id).then(res => {
                const fee = this.parsePostcodeFeePayload(res);
                this.postcodeFee = fee;
                this.postcodeFeeModalExisting = fee;
                this.postcodeFeeModalOpen = true;
            }).catch(() => {
                this.postcodeFee = null;
                this.postcodeFeeModalExisting = null;
                this.postcodeFeeModalOpen = true;
            });
        },
        onPostcodeFeeModalSaved: function () {
            this.postcodeFeeModalOpen = false;
            this.loadPostcodeFee();
        },
        onPostcodeFeeModalDeleted: function () {
            this.postcodeFeeModalOpen = false;
            this.loadPostcodeFee();
        },
        loadCustomer: function () {
            this.customerService.get(this.id).then(
                xhr => {
                    this.customer = xhr.data;
                    this.jobs = [];
                    this.forms = [];
                    window.metaTitle('Customer | ' + this.customer.company_name);
                    this.setCommentsCustomerId(this.customer.id);
                    this.setCommentsSiteId('*');
                    this.customerService.jobs(this.customer).then(({data}) => {
                        this.jobs = data.map(job => {
                            if (job.first_time_slot) {
                                job.first_time_slot.start = moment(job.first_time_slot.start);
                            }
                            return job;
                        });
                        this.$forceUpdate();
                    });
                    this.formsLoading = true;
                    this.customerService.forms(this.customer).then(({data}) => {
                        this.forms = data;
                        this.formsLoading = false;
                        this.$forceUpdate();
                    });
                },
                error => {
                    this.$refs.errorModal.show(error);
                }
            );
        },
        confirmDelete: function () {
            this.$refs.deleteModals.show();
        },
        errorClose: function () {
            this.$router.push({name: this.routeBase + '.customers.search'});
        },
        newForm: function () {
            this.$refs.newFormModal.show();
        },
    }
};
</script>
<style scoped>
.overdue {
	color: red;
	font-weight: bold;;
}
</style>


// WEBPACK FOOTER //
// resources/assets/js/components/office/customers/ShowComponent.vue